import { useQuery } from '@tanstack/react-query';
import { Fragment } from 'react';

import type { Lead } from '../api/types';
import { useProject } from '../projects/context';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { callFacts, leadFactLabels } from './callFacts';

export function CallObjectFacts({ lead }: { lead: Lead }) {
  const { project } = useProject();
  const papi = useProjectApi();
  const objects = useQuery({
    queryKey: projectKeys.leadObjects(project.id, lead.id),
    queryFn: ({ signal }) => papi.leadObjects(lead.id, signal),
  });
  const loaded = objects.isSuccess;
  const items = objects.data?.items ?? [];
  const main = items.find((o) => o.is_main) ?? items[0];
  const { facts, missing } = callFacts(loaded ? main : undefined, lead);
  const shown = loaded ? facts : facts.filter((f) => leadFactLabels.includes(f.label));
  if (shown.length === 0 && (!loaded || missing.length === 0)) return null;
  return (
    <section className="call-object" aria-label="Objekt">
      <dl className="facts lead-facts">
        {shown.map((f) => (
          <Fragment key={f.label}>
            <dt>{f.label}</dt>
            <dd>{f.label === 'Objekt' ? <strong>{f.value}</strong> : f.value}</dd>
          </Fragment>
        ))}
      </dl>
      {loaded && missing.length > 0 && <p className="muted small">Im Gespräch erfragen: {missing.join(', ')}.</p>}
    </section>
  );
}
